import { FleetRequester } from '@cobliteam/api-lib';
import { DatadogTrack } from '@cobliteam/datadog-rum';
import { Environment } from '@cobliteam/react-environments';
import { alertErrorUpload, loadFleetLogoUrlFailed, loadFleetLogoUrlSucceeded } from '@cobliteam/store/src/Fleet/actionCreators';
import { type AlertErrorUpload, FleetActionNames, type LoadFleetLogoUrlRequest, type UploadFleetLogo } from '@cobliteam/store/src/Fleet/actions';
import moment from 'moment';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'sonner';

const env = Environment.getInstance().getEnvironment();

const fleetRequester = new FleetRequester({ host: env.herbieApiHost });

export function makeDifferentUrl(url: string) {
  // We are change value of url of logo because of immutability of store
  // it's same value but this change needs to happen to re-render component
  const timestamp = moment().valueOf();
  return `${url}?${timestamp}`;
}

export function* loadFleetLogoUrlRequestSaga(action: LoadFleetLogoUrlRequest) {
  const fleetId = action.payload;
  try {
    const url: string = yield call(fleetRequester.getLogoUrl, fleetId);
    const newUrl = makeDifferentUrl(url);
    yield put(loadFleetLogoUrlSucceeded(newUrl));
  } catch (err) {
    yield put(loadFleetLogoUrlFailed());
  }
}

export function* uploadFleetLogoSaga(action: UploadFleetLogo) {
  const blob = action.payload;
  try {
    const url: string = yield call(fleetRequester.uploadLogo, blob);
    const newUrl = makeDifferentUrl(url);
    yield put(loadFleetLogoUrlSucceeded(newUrl));
    toast.success('Logo salvo com sucesso!');
  } catch (err) {
    // @ts-expect-error we need to add error type
    yield put(alertErrorUpload(err));
  }
}

export function* deleteFleetLogoRequestSaga() {
  try {
    yield call(fleetRequester.deleteLogo);
    yield put(loadFleetLogoUrlSucceeded(null));
  } catch (err) {
    toast.error('Falha ao remover a logo. Tente novamente.');
  }
}

export function alertErrorUploadSaga(action: AlertErrorUpload) {
  const error = action.payload;
  DatadogTrack.error(error as Error, { EventSource: 'FleetSaga' });
  toast.error('Falha ao salvar logo. Tente novamente.');
}

export function* FleetSagasListener() {
  yield all([
    takeLatest(FleetActionNames.UPLOAD_FLEET_LOGO, uploadFleetLogoSaga),
    takeLatest(FleetActionNames.LOAD_FLEET_LOGO_URL_REQUEST, loadFleetLogoUrlRequestSaga),
    takeLatest(FleetActionNames.ERROR_ALERT_FLEET_LOGO, alertErrorUploadSaga),
    takeLatest(FleetActionNames.DELETE_FLEET_LOGO_REQUEST, deleteFleetLogoRequestSaga),
  ]);
}
